@if (blockUi.isBlocking()) {
  <div class="block-ui-wrapper" role="status" aria-busy="true">
    <div class="block-ui-spinner">
      <div class="loader"></div>
      @if (blockUi.message()) {
        <div class="message">{{ blockUi.message() }}</div>
      }
    </div>
  </div>
}
